import React from "react";
import css from "../../modules/SelectionEvaluation.module.css";
const EvaluationRow = (props) => {
  const goodLength = props.goodWords;
  const badLength = props.badWords;
  const regLength = 12 - goodLength - badLength;

  return (
    <React.Fragment>
      <tr>
        <td className={css.row}>{props.id}</td>
        {Array.from({ length: goodLength }).map((_, index) => (
          <td
            style={{
              backgroundColor: "#ee7f00",
              border: "solid",
              borderWidth: "1px",
            }}
            className={css.border}
            key={index}
          ></td>
        ))}

        {Array.from({ length: regLength }).map((_, index) => (
          <td className={css.checkers} key={index}></td>
        ))}

        {Array.from({ length: badLength }).map((_, index) => (
          <td
            style={{
              backgroundColor: "#006ab2",
              border: "solid",
              borderWidth: "1px",
            }}
            className={css.border}
            key={index}
          ></td>
        ))}
        <div className={css.description}>
          <td className={css.sentence}>{props.s}</td>
          <td className={css.title}>{props.t}</td>
        </div>
      </tr>
    </React.Fragment>
  );
};

export default EvaluationRow;
